import { Form, InputNumber } from 'antd';

import styles from '../RoomDiscount.module.scss';

import { RevenueShare } from './RevenueShare';

type ConstantDiscountRowProps = {
  currencyFormatter: (value: number) => string;
  formRoomPrice?: number | null;
  defaultNightRoomDiscount?: number | null;
};

export const ConstantDiscountRow = ({
  currencyFormatter,
  formRoomPrice,
  defaultNightRoomDiscount,
}: ConstantDiscountRowProps) => (
  <div className={styles.discountRow}>
    <span>Apply a discount of</span>
    <div className={styles.discountRateInput}>
      <Form.Item
        noStyle
        name="defaultNightRoomDiscount"
        validateStatus={!defaultNightRoomDiscount ? 'error' : ''}
        rules={[{ required: true, message: 'Required' }]}
      >
        <InputNumber min={0} max={100} addonAfter="%" />
      </Form.Item>
      {(formRoomPrice === null ||
        formRoomPrice === undefined ||
        defaultNightRoomDiscount === null ||
        defaultNightRoomDiscount === undefined) && (
        <span className={styles.errorMessage}>
          {formRoomPrice === null || formRoomPrice === undefined
            ? 'Average BAR required to calculate revenue share'
            : 'Default discount required'}
        </span>
      )}
      {formRoomPrice &&
        defaultNightRoomDiscount !== null &&
        defaultNightRoomDiscount !== undefined &&
        defaultNightRoomDiscount > 0 && (
          <div className={styles.pricePreview}>
            <span className={styles.description}>
              Estimated room revenue share =
            </span>{' '}
            <RevenueShare
              currencyFormatter={currencyFormatter}
              basePrice={formRoomPrice}
              discountPercent={defaultNightRoomDiscount}
            />
          </div>
        )}
    </div>
    <span>to all rooms within packages</span>
  </div>
);
